import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {useSnackAction} from "../../shopdrawing/hardware/SnackAction";
import {useHwAPI} from "../../shopdrawing/hardware/HardwareGeneric";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {useReloader} from "../../shopdrawing/hardware/ReloadContext";
import {useAlternative} from "../alternative/Alternative";
import CachedIcon from '@mui/icons-material/Cached';
import {useCallback, useRef} from "react";
import {useSyncedRef} from "../../../../misc/SyncedRef";

export function HardwareReSequence() {
    const reSequence = useReSequence({});

    return (
        <SmallGreyButton startIcon={<CachedIcon />} onClick={() => reSequence()}>Resequence</SmallGreyButton>
    )
}

export function useReSequence(props: {
    onDone?:() => void;
}) {
    const hwapi = useHwAPI();
    const project = useProjectId();
    const reload = useReloader();
    const alternative = useAlternative();
    const onDoneRef = useSyncedRef(props.onDone);

    const action = useSnackAction(async (input: {
        project: number;
        alternative?: number;
    }) => {
        await hwapi.reSequence(input as any)
        reload.current();
        if(onDoneRef.current) {
            onDoneRef.current();
        }
    }, {
        success: "Updated sequence",
    })

    const callbackRef = useRef(action.callback);
    callbackRef.current = action.callback;

    return useCallback(() => {
        callbackRef.current({
            project: project,
            alternative: alternative,
        });
    }, [project, alternative])
}